import React, { useState } from "react";
import { Button } from "react-bootstrap";
import UserMenu from "./UserMenu";
//import FloatingButton from "./UserMenu1";
import FloatingButton from "./UserMenu";
import {navigateTo} from './../utils/commonFunctions'
import AutenticationService from "../services/Authentication.service";

export default function SidebarComponent({handelChangeButton,listaRecientes,listaFijas,handleChange}) {
 
  return (
    <div className="sidebar-content" 
      style={{ display: "flex", flexDirection: "column" }}
    >
      <div style={{ flexShrink: 0, padding:'1rem 2rem',width:'100%' }}>
        <img src="/images/logo.png" alt="Logo" 
          className="logo d-none d-md-block"           
        />
        <Button 
          className="mb-3 btn-nuevo"
          onClick={handelChangeButton}
        >
          <svg className="mb-1" width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.66667 16.8691C1.20833 16.8691 0.815972 16.7059 0.489583 16.3796C0.163194 16.0532 0 15.6608 0 15.2025V3.53581C0 3.07747 0.163194 2.68511 0.489583 2.35872C0.815972 2.03234 1.20833 1.86914 1.66667 1.86914H7.10417C7.38194 1.86914 7.59028 1.95595 7.72917 2.12956C7.86806 2.30317 7.9375 2.49414 7.9375 2.70247C7.9375 2.91081 7.86458 3.10178 7.71875 3.27539C7.57292 3.449 7.36111 3.53581 7.08333 3.53581H1.66667V15.2025H13.3333V9.76497C13.3333 9.4872 13.4201 9.27886 13.5938 9.13997C13.7674 9.00109 13.9583 8.93164 14.1667 8.93164C14.375 8.93164 14.566 9.00109 14.7396 9.13997C14.9132 9.27886 15 9.4872 15 9.76497V15.2025C15 15.6608 14.8368 16.0532 14.5104 16.3796C14.184 16.7059 13.7917 16.8691 13.3333 16.8691H1.66667ZM5 11.0358V9.01497C5 8.79275 5.04167 8.58095 5.125 8.37956C5.20833 8.17817 5.32639 8.00109 5.47917 7.84831L12.6458 0.681641C12.8125 0.514974 13 0.389974 13.2083 0.306641C13.4167 0.223307 13.625 0.181641 13.8333 0.181641C14.0556 0.181641 14.2674 0.223307 14.4688 0.306641C14.6701 0.389974 14.8542 0.514974 15.0208 0.681641L16.1875 1.86914C16.3403 2.03581 16.4583 2.21984 16.5417 2.42122C16.625 2.62261 16.6667 2.82747 16.6667 3.03581C16.6667 3.24414 16.6285 3.449 16.5521 3.65039C16.4757 3.85178 16.3542 4.03581 16.1875 4.20247L9.02083 11.3691C8.86806 11.5219 8.69097 11.6434 8.48958 11.7337C8.28819 11.824 8.07639 11.8691 7.85417 11.8691H5.83333C5.59722 11.8691 5.39931 11.7893 5.23958 11.6296C5.07986 11.4698 5 11.2719 5 11.0358ZM6.66667 10.2025H7.83333L12.6667 5.36914L12.0833 4.78581L11.4792 4.20247L6.66667 9.01497V10.2025Z" fill="white"/>
          </svg>
          {' '}
          Nuevo Chat
        </Button>
      </div>
      <div style={{ 
        flexGrow: 1
        , overflowY: 'auto'
        , width:'100%'
        , padding:'0 1rem'          
      }}>        
        
        { listaFijas?.length>0&&<>
          <span className="sidebar-title">
            <svg className="me-1" width="12" height="17" viewBox="0 0 12 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.8907 10.7583L10.8907 10.7582C11.0639 10.5841 11.15 10.3663 11.15 10.1152V9.68164C11.15 9.55139 11.1255 9.42889 11.0737 9.3167C11.0247 9.21056 10.959 9.11602 10.8769 9.03391L9.15 7.30701V2.01914H9.25C9.50096 2.01914 9.71809 1.93131 9.8912 1.75569C10.0636 1.58082 10.15 1.36403 10.15 1.11477C10.15 0.865461 10.0635 0.649511 9.89013 0.477141C9.7168 0.304815 9.5 0.219141 9.25 0.219141H2.75C2.49904 0.219141 2.28191 0.306973 2.1088 0.48259C1.93642 0.657465 1.85 0.874248 1.85 1.12352C1.85 1.37282 1.93649 1.58877 2.10987 1.76114C2.2832 1.93347 2.5 2.01914 2.75 2.01914H2.85V7.30701L1.1231 9.03391C1.04099 9.11602 0.975294 9.21056 0.926306 9.3167C0.874527 9.42889 0.85 9.55139 0.85 9.68164V10.1152C0.85 10.3663 0.936111 10.5841 1.10925 10.7582L1.1093 10.7583C1.28252 10.9323 1.4995 11.0191 1.75 11.0191H5.1V15.4941C5.1 15.7451 5.18783 15.9622 5.36345 16.1353C5.53832 16.3077 5.75511 16.3941 6.00437 16.3941C6.25368 16.3941 6.46963 16.3076 6.642 16.1343C6.81432 15.9609 6.9 15.7441 6.9 15.4941V11.0191H10.25C10.5005 11.0191 10.7175 10.9323 10.8907 10.7583ZM7.35 7.99414V8.05627L7.39393 8.10021L8.51287 9.21914H3.48713L4.60607 8.10021L4.65 8.05627V7.99414V2.01914H7.35V7.99414Z" fill="#00639B" stroke="#00639B" strokeWidth="0.3"/>
            </svg>
            {' '}
            Conversaciones fijadas
          </span>
          <ul className="sidebar-list mt-3 mb-4">
            {listaFijas?.map((item, index) => (
              <li key={index} className="fs-6">{item}</li>
            ))}
          </ul>
        </>}

        { listaRecientes.length>0&&<>
          <span className="sidebar-title">
            <svg className="me-1" width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.8343 16.0191C12.8631 16.0191 14.8088 15.2131 16.2434 13.7785C17.678 12.3439 18.484 10.398 18.484 8.36914C18.484 6.34023 17.678 4.39443 16.2434 2.95977C14.8087 1.52512 12.8629 0.719141 10.834 0.719141C8.80508 0.719141 6.85927 1.52512 5.42462 2.95977C4.02536 4.35903 3.22413 6.24454 3.18545 8.21914H0.833984H0.476292L0.726993 8.47427L4.02699 11.8326L4.13292 11.9404L4.23992 11.8337L7.60659 8.47534L7.86342 8.21914H7.50065H5.15263C5.19095 6.7662 5.78484 5.38084 6.81526 4.35042C7.88109 3.28459 9.32667 2.68581 10.834 2.68581C12.3413 2.68581 13.7869 3.28459 14.8527 4.35042C15.9185 5.41625 16.5173 6.86183 16.5173 8.36914C16.5173 9.87645 15.9185 11.322 14.8527 12.3879C13.7869 13.4537 12.3413 14.0525 10.834 14.0525C9.26737 14.0525 7.84688 13.4114 6.8238 12.3802L6.71774 12.2733L6.61125 12.3797L5.42792 13.5631L5.32241 13.6686L5.42736 13.7746C6.13438 14.4892 6.97669 15.0557 7.90508 15.441C8.8334 15.8264 9.82919 16.0229 10.8343 16.0191ZM10.8343 16.0191C10.8342 16.0191 10.8341 16.0191 10.834 16.0191V15.8691L10.8346 16.0191C10.8345 16.0191 10.8344 16.0191 10.8343 16.0191ZM11.4007 5.03581V4.88581H11.2507H10.8343V6.01914H12.4173V5.86914H11.4007Z" fill="#00639B" stroke="#00639B" strokeWidth="0.3"/>
            </svg>
            {''}
            Conversaciones recientes
          </span>
          <ul className="sidebar-list mt-3">
            {listaRecientes?.map((item, index) => (
              <li key={index} className="fs-6" onClick={()=>{handleChange({texto:item.content,isUser:true})}} >{item.content}</li>
            ))}
          </ul>
        </>}

      </div>      
      {
        !AutenticationService.getRegistered()&&<>
          <div className="sidebar-message" style={{ flexShrink: 0}}>
            <svg className="d-none d-md-inline" width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clipPath="url(#clip0_724_3545)">
              <path d="M20.5668 5.7207H6.17578V19.1286H20.5668V5.7207Z" fill="white"/>
              <path d="M12.4777 0C5.86312 0 0.5 5.36312 0.5 11.9777C0.5 18.5922 5.86312 23.9554 12.4777 23.9554C13.4608 23.9554 14.8911 23.9554 16.4553 23.9554L6.6229 14.1229V9.8324H10.3324V6.07822H14.6229L24.4554 15.9106C24.4554 14.3464 24.4554 12.9162 24.4554 11.933C24.5 5.36312 19.1368 0 12.4777 0Z" fill="#FDAE01"/>
              <path d="M14.6675 9.83231H18.377V14.1228H14.6228V17.877H10.3323V14.1228H6.57812L16.4105 23.9552C20.12 23.9552 24.4552 23.9552 24.4552 23.9552C24.4552 23.9552 24.4552 19.62 24.4552 15.9105L14.6228 6.07812V9.83231H14.6675Z" fill="#E5A324"/>
              <path d="M20.4074 14.7689V9.31641H4.63086V14.7689H20.4074Z" fill="white"/>
              <path d="M9.75 19.927H15.2026V4.15039H9.75V19.927Z" fill="white"/>
            </g>        
            </svg>
            <div className="mt-2">
              Mejora tu plan y accede a funciones y contenido exclusivo dentro de El Universal
            </div>
            <Button className="btn-upgrade mt-2" onClick={navigateTo}>
              <svg className="me-1 d-md-none" width="18" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_724_3545)">
                <path d="M20.5668 5.7207H6.17578V19.1286H20.5668V5.7207Z" fill="white"/>
                <path d="M12.4777 0C5.86312 0 0.5 5.36312 0.5 11.9777C0.5 18.5922 5.86312 23.9554 12.4777 23.9554C13.4608 23.9554 14.8911 23.9554 16.4553 23.9554L6.6229 14.1229V9.8324H10.3324V6.07822H14.6229L24.4554 15.9106C24.4554 14.3464 24.4554 12.9162 24.4554 11.933C24.5 5.36312 19.1368 0 12.4777 0Z" fill="#FDAE01"/>
                <path d="M14.6675 9.83231H18.377V14.1228H14.6228V17.877H10.3323V14.1228H6.57812L16.4105 23.9552C20.12 23.9552 24.4552 23.9552 24.4552 23.9552C24.4552 23.9552 24.4552 19.62 24.4552 15.9105L14.6228 6.07812V9.83231H14.6675Z" fill="#E5A324"/>
                <path d="M20.4074 14.7689V9.31641H4.63086V14.7689H20.4074Z" fill="white"/>
                <path d="M9.75 19.927H15.2026V4.15039H9.75V19.927Z" fill="white"/>
              </g>        
              </svg>
              Mejorar plan
            </Button>
          </div>
        </>
      }
      
      <div 
        className="d-block d-md-none"
        style={{
          width:'100%',
          flexShrink: 0,
          padding: '10px 15px',
          borderTop: '1px solid rgba(0, 0, 0, 0.1)'
        }}
      >
        <FloatingButton
          containerClass="user-info-container"
          buttonClass="floating-button"
          menuClass="floating-menu"
          textClass="user-texts"
          showUserTextsInMenu={false}
        />
      </div>
    </div>
  );
}  
 